"use strict"; //All my JavaScript written in Strict Mode http://ecma262-5.com/ELS5_HTML.htm#Annex_C

var machine, previewFileReader;

(function () {


    // ======== private vars ========
    var socket;
    var adr = 'ws://127.0.0.1:8895';
    let $body = $('body');

   /* $.ajaxSetup({
        headers: {
            'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
        }
    });*/


    ////////////////////////////////////////////////////////////////////////////
    var init = function () {
        var socket = io.connect(adr);


        $body.on('click', '.battle-useers__status.join a', function(e) {
            e.preventDefault();
            let nowGameId = $('#gameId').val(),
                $user = thisUserObj;
            socket.emit('joinBattle', nowGameId, $user);
        });

        $body.on('click', '.battle-useers__leave', function(e) {
            e.preventDefault();
            let nowGameId = $('#gameId').val(),
                $user = thisUserObj;
            if($user.id === $(this).closest('.battle-useers__el').data('userid')){
                socket.emit('leaveBattle', nowGameId, $user);
            }

        });

        socket.on('joinBattle', function (nowGameId, $user) {
            if(nowGameId === $('#gameId').val()){
                let nowUserEl = $('.battle-useers__el.no-place').eq(0);

                $('#countFreeSpots').val($('#countFreeSpots').val() - 1);

                nowUserEl.removeClass('no-place').attr('data-userid', $user.id)
                         .find('.battle-useers__status')
                                                       .removeClass('join')
                                                       .addClass('ready').html('<img src="img/icon-ready.png" alt=""><span>Ready!</span>');
                nowUserEl.removeClass('no-place')
                    .find('.battle-useers__avatar img').attr('src',$user.avatar);
                nowUserEl.removeClass('no-place')
                    .find('.battle-useers__name').html($user.name);

                if($user.id === thisUserObj.id && $('#countFreeSpots').val() > 0){
                    nowUserEl.find('.battle-useers__body').append('<div class="battle-useers__leave"><img src="img/leave.png" alt=""><span>Exit</span></div>');
                }

                setTimeout(battleStart, 1500);
            }
        });

        socket.on('leaveBattle', function (nowGameId, $user) {
            if(nowGameId === $('#gameId').val()){
                let nowUserEl = $('.battle-useers__el[data-userid='+$user.id+']');

                $('#countFreeSpots').val($('#countFreeSpots').val() + 1);

                nowUserEl.removeAttr('data-userid').addClass('no-place');
                nowUserEl.find('.battle-useers__avatar img').attr('src','img/no-user.png');
                nowUserEl.find('.battle-useers__name').html('Waiting for a player');
                nowUserEl.find('.battle-useers__leave').remove();
                nowUserEl.find('.battle-useers__status')
                         .addClass('join')
                         .removeClass('ready')
                         .html('<span>Fight or run!</span><a href="#">Join</a>');
            }
        });
    };

    return {
        ////////////////////////////////////////////////////////////////////////////
        // ---- onload event ----
        load : function () {
            window.addEventListener('load', function () {
                init();
            }, false);
        }
    }
})().load();


function readURL(input){

    if (input.files && input.files[0]) {
        var reader = new FileReader();

        reader.onload = function (e) {
            previewFileReader = e.target.result;
        };

        reader.readAsDataURL(input.files[0]);
    }
}
